(function() {
  'use strict';

  const CONFIG = {
    klaviyoListId: 'YcSJqT',
    klaviyoCompanyId: 'SfGDYC',
    autoCloseDelay: 3000
  };

  // Elementi globali
  let globalPopup, globalOverlay, globalForm, globalClose;
  let globalProductTitle, globalProductId, globalProductTitleInput;
  let globalProductHandle, globalProductUrl, globalProductImage;

  function init() {
    globalPopup = document.getElementById('globalReminderPopup');
    globalOverlay = document.getElementById('globalReminderOverlay');
    globalForm = document.getElementById('globalReminderForm');
    globalClose = document.getElementById('globalReminderClose');
    globalProductTitle = document.getElementById('globalProductTitle');
    globalProductId = document.getElementById('globalProductId');
    globalProductTitleInput = document.getElementById('globalProductTitleInput');
    globalProductHandle = document.getElementById('globalProductHandle');
    globalProductUrl = document.getElementById('globalProductUrl');
    globalProductImage = document.getElementById('globalProductImage');

    const openBtn = document.getElementById('openReminderSlide');
    const closeBtn = document.getElementById('closeReminderSlide');
    const slidein = document.getElementById('reminderSlidein');
    const overlay = document.getElementById('reminderOverlay');
    const form = document.getElementById('reminderForm');

    if (openBtn && slidein && !globalPopup) {
      openBtn.addEventListener('click', function() {
        openPopup(slidein, overlay);
      });
      if (closeBtn) {
        closeBtn.addEventListener('click', function() {
          closePopup(slidein, overlay);
        });
      }
      if (overlay) {
        overlay.addEventListener('click', function() {
          closePopup(slidein, overlay);
        });
      }
      if (form) {
        form.addEventListener('submit', function(e) {
          handleSubmit(e, form);
        });
      }
    }

    if (openBtn && globalPopup) {
      openBtn.addEventListener('click', function() {
        const pageForm = document.getElementById('reminderForm');
        if (pageForm) {
          const formData = new FormData(pageForm);
          openGlobalPopup(
            formData.get('product_title'),
            formData.get('product_id'),
            formData.get('product_handle'),
            formData.get('product_url'),
            formData.get('product_image')
          );
        }
      });
    }

    if (globalPopup) {
      const cardButtons = document.querySelectorAll('[data-open-reminder]');
      cardButtons.forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          openGlobalPopup(
            btn.getAttribute('data-product-title'),
            btn.getAttribute('data-product-id'),
            btn.getAttribute('data-product-handle'),
            btn.getAttribute('data-product-url'),
            btn.getAttribute('data-product-image')
          );
        });
      });

      if (globalClose) {
        globalClose.addEventListener('click', function() {
          closePopup(globalPopup, globalOverlay);
        });
      }

      if (globalOverlay) {
        globalOverlay.addEventListener('click', function() {
          closePopup(globalPopup, globalOverlay);
        });
      }

      if (globalForm) {
        globalForm.addEventListener('submit', function(e) {
          handleSubmit(e, globalForm);
        });
      }
    }

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        if (globalPopup && globalPopup.classList.contains('active')) {
          closePopup(globalPopup, globalOverlay);
        }
        if (slidein && slidein.classList.contains('active')) {
          closePopup(slidein, overlay);
        }
      }
    });
  }

  function openGlobalPopup(title, id, handle, url, image) {
    if (globalProductTitle) globalProductTitle.textContent = title;
    if (globalProductId) globalProductId.value = id;
    if (globalProductTitleInput) globalProductTitleInput.value = title;
    if (globalProductHandle) globalProductHandle.value = handle;
    if (globalProductUrl) globalProductUrl.value = url;
    if (globalProductImage) globalProductImage.value = image;
    
    openPopup(globalPopup, globalOverlay);
  }

  function openPopup(popup, overlay) {
    if (popup) popup.classList.add('active');
    if (overlay) overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closePopup(popup, overlay) {
    if (popup) popup.classList.remove('active');
    if (overlay) overlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  async function handleSubmit(e, form) {
    e.preventDefault();

    if (CONFIG.klaviyoListId === 'XXXXXX' || !CONFIG.klaviyoListId) {
      console.error('Klaviyo List ID non configurato!');
      showError(form, 'Configurazione non completata. Contatta il supporto.');
      return;
    }

    setLoading(form, true);
    hideError(form);

    const formData = new FormData(form);
    const data = {
      email: formData.get('email'),
      firstName: formData.get('first_name'),
      productId: formData.get('product_id'),
      productTitle: formData.get('product_title'),
      productHandle: formData.get('product_handle'),
      productUrl: formData.get('product_url'),
      productImage: formData.get('product_image')
    };

    try {
      await subscribeToKlaviyo(data);
      showSuccess(form);
      
      if (CONFIG.autoCloseDelay > 0) {
        setTimeout(function() {
          if (globalPopup && globalPopup.classList.contains('active')) {
            closePopup(globalPopup, globalOverlay);
          }
          const slidein = document.getElementById('reminderSlidein');
          const overlay = document.getElementById('reminderOverlay');
          if (slidein && slidein.classList.contains('active')) {
            closePopup(slidein, overlay);
          }
          setTimeout(function() { resetForm(form); }, 500);
        }, CONFIG.autoCloseDelay);
      }
    } catch (error) {
      console.error('Errore iscrizione Klaviyo:', error);
      showError(form, 'Si è verificato un errore. Riprova più tardi.');
    } finally {
      setLoading(form, false);
    }
  }

  async function subscribeToKlaviyo(data) {
    const endpoint = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + CONFIG.klaviyoCompanyId;

    const payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Coming Soon Reminder',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: data.email,
                first_name: data.firstName,
                properties: {
                  'Coming Soon Product ID': data.productId,
                  'Coming Soon Product Title': data.productTitle,
                  'Coming Soon Product URL': data.productUrl,
                  'Coming Soon Product Image': data.productImage,
                  'Coming Soon Signup Date': new Date().toISOString()
                }
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: CONFIG.klaviyoListId
            }
          }
        }
      }
    };

    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2024-02-15'
      },
      body: JSON.stringify(payload)
    });

    // Klaviyo restituisce 202 per successo
    if (response.status === 202 || response.ok) {
      // Traccia anche l'evento se _learnq è disponibile
      if (typeof window._learnq !== 'undefined') {
        window._learnq.push(['identify', {
          '$email': data.email,
          '$first_name': data.firstName
        }]);
        window._learnq.push(['track', 'Coming Soon Signup', {
          'Product ID': data.productId,
          'Product Title': data.productTitle,
          'Product URL': data.productUrl,
          'Product Image': data.productImage
        }]);
      }
      return true;
    }

    const errorData = await response.json().catch(() => ({}));
    console.error('Klaviyo response:', errorData);
    throw new Error('Klaviyo API error: ' + response.status);
  }

  function setLoading(form, loading) {
    const submitBtn = form.querySelector('.reminder-submit');
    const btnText = form.querySelector('.btn-text');
    const btnLoading = form.querySelector('.btn-loading');
    
    if (submitBtn) submitBtn.disabled = loading;
    if (btnText) btnText.style.display = loading ? 'none' : 'inline';
    if (btnLoading) btnLoading.style.display = loading ? 'inline-flex' : 'none';
  }

  function showSuccess(form) {
    form.style.display = 'none';
    const container = form.closest('.reminder-content') || form.parentElement;
    const successEl = container.querySelector('.reminder-success');
    if (successEl) successEl.style.display = 'block';
  }

  function showError(form, message) {
    const container = form.closest('.reminder-content') || form.parentElement;
    const errorEl = container.querySelector('.reminder-error');
    if (errorEl) {
      errorEl.querySelector('p').textContent = message;
      errorEl.style.display = 'block';
    }
  }

  function hideError(form) {
    const container = form.closest('.reminder-content') || form.parentElement;
    const errorEl = container.querySelector('.reminder-error');
    if (errorEl) errorEl.style.display = 'none';
  }

  function resetForm(form) {
    form.reset();
    form.style.display = 'flex';
    const container = form.closest('.reminder-content') || form.parentElement;
    const successEl = container.querySelector('.reminder-success');
    const errorEl = container.querySelector('.reminder-error');
    if (successEl) successEl.style.display = 'none';
    if (errorEl) errorEl.style.display = 'none';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();